import { useEffect } from "react";

export default function useToggleScroll(states) {
  useEffect(() => {
    const shouldDisableScroll = states.some((state) => state);

    if (shouldDisableScroll) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    // Cleanup function to remove the class when the component is unmounted
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [states]);
}
